import router from "@/router";
import { devInfo } from "@/utils/device";
import { JSCallAPP } from "./interactive";

/**
 * 回退
 * 如果地址栏查询参数中含有 no_back_app=1 ，则在 H5 中回退
 * 否则回退到 APP
 */
export const goBack = () => {
  const route = router.currentRoute;

  if (route.query && route.query.no_back_app) {
    router.go(-1);
  } else {
    if(devInfo.isDingTalkDevice){
      router.go(-1);
    }else{
      JSCallAPP({
        method: "back",
      });
    }
    
  }
};
